/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../../environment';
import { Api } from '../../axiosApi';
export interface IListagemMovimento {
  idmov: string;
  emissao: Date;
  numero: string;
  descricao: string;
  cpf: string;
  nome: string;
  total: number;
}
export interface IitensMovimentoDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  localizado?: string;
  original?: boolean;
  ean?: string;
  subtotal: number;
  voutros: number;
  desconto: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface IgetMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  numero: string;
  faturado: boolean;
  idoperacao: string;
  dataoperacao: string;
  emissao: string;
  caixa: string;
  contapagas: string;
  nome: string;
  total: number;
  desconto: number;
  tipo: number;
  vendedor: string;
  vprod: number;
  acrescimo: number;
  itens: IitensMovimentoDialog[];
}
interface IDetalheMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
}
interface IDetalheMovimentoupdate {
  idparceiro: string;
  idplanoconta: string;
  idoperacoes: string;
  emissao: string;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
}
interface IItensids {
  iditens: string;
}
interface IParcelasFaturamento {
  idpagar: string;
  idplanoconta: string;
  emissao: string;
  vencimento: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  parcela: string;
  vpagar: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  vpago: number;
  vparcela: number;
  vcompra: number;
  qtdparcelas: number;
}
type TotalCount = {
  data: IListagemMovimento[];
  totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (page = 1, dataInicial = '', dataFinal = '', filter = '', tipo = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/entradaestoque?page=${page}&limit=${limit}&tipo=${tipo}&filter=${filter}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IgetMovimento | Error> => {
  try {
    const { data } = await Api.get(`/entradaestoque/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (
  dados: IDetalheMovimento,
  dadositens: IitensMovimentoDialog[],
  faturamento: IParcelasFaturamento[]
): Promise<string | Error> => {
  try {

    const dadosExtraidos = dadositens.map(
      ({ descricao, filtro, marca, referencia, ean, idref, localizado, original, ...rest }) => ({
        idmov: dados.idmov,
        tipo: 1,
        ...rest,
      })
    );

    const pfaturamento = faturamento.map(
      ({ qtdparcelas, ...rest }) => ({
        idmov: dados.idmov,
        ...rest,
      })
    );

    const dadosEntrada = { ...dados, tipo: 1 };
    await Api.post('/entradaestoque', [
      dadosEntrada,
      dadosExtraidos,
      pfaturamento,
    ]);

    return dados.idmov;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], iddeletados: IItensids[], faturamento: IParcelasFaturamento[]): Promise<void | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({ descricao, filtro, marca, referencia, ean, idref, localizado, original, ...restoDoObjeto }) => ({ tipo: 1, idmov: dados.idmov, ...restoDoObjeto }));
    const { ...dadosIDetalheEntrada } = dados;
    const dadosEntrada = { ...dadosIDetalheEntrada,  tipo: 1};
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: dados.idmov, ...restoDoObjeto }));
    await Api.put(`/entradaestoque/${id}`, [dadosEntrada, dadosExtraidos, iddeletados, Pfaturamento]);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/entradaestoque/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const MovimentoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
};